/**
 * Extract the creation date encoded in a MongoDB ObjectId.
 *
 * The first 4 bytes (8 hex chars) of an ObjectId hold the document creation
 * time as a Unix timestamp in seconds. This lets us display a creation date
 * without persisting a dedicated `created_at` field on the model.
 */
export function getObjectIdDate(id: string): Date {
  return new Date(parseInt(id.substring(0, 8), 16) * 1000)
}
